/* Cart Upcell js */

(function () {
  // --- Global variables ---
  window.upsellSwiper = null;

  // --- Initialize / re-initialize Swiper slider ---
  window.initUpsellSwiper = function() {

      // Initialize Swiper
    window.upsellSwiper = new Swiper('.cart-upsell-slider', {
      slidesPerView: 1,
      spaceBetween: 12,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        640: { slidesPerView: 2 },
        1024: { slidesPerView: 2 }
      }
    });
  };

  // --- Manual refresh function ---
  window.refreshUpsellSwiper = function() {
    setTimeout(window.initUpsellSwiper, 100);
  };

  function checkIfAllUpsellsAdded() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const wrapper = document.querySelector('.gt-customcart-upsell-wr');
        if (!wrapper) return;

        const cartIds = cart.items.map(i => i.product_id);
        const items = wrapper.querySelectorAll('.upsell-item');
        let allAdded = [...items].every(item => cartIds.includes(+item.dataset.productId));

        wrapper.style.display = allAdded ? "none" : "";
      })
      .catch(console.error);
  }

  // --- Update cartProductIds whenever cart changes ---
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (args[0].includes('/cart/')) {
      response.clone().json().then(cart => {
        window.refreshUpsellSwiper();
      }).catch(() => window.refreshUpsellSwiper());
    }
    return response;
  };

  /* Handle add-to-cart from slider buttons */

  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('upsell-add-btn')) {

      const btn = e.target;
      const card = btn.closest('.upsell-item');
      
      const variantInput = card.querySelector('.upsell-variant-select:checked, .upsell-variant-select[type="hidden"]');
      const variantId = variantInput ? variantInput.value : null;

      
      if (!variantId) {
        alert("Please select a variant.");
        return;
      }

      // If button is disabled (sold out), do nothing
      if (btn.disabled) return;

      // Show loader + disable button
      btn.disabled = true;
      btn.textContent = 'Adding…';

      // Add to cart via Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => {
        // Refresh cart drawer
          fetch(`/cart?sections=cart-drawer`)
          .then(res => res.json())
          .then((sections) => {
              const sectionIds = ['cart-drawer'];
              for (const sectionId of sectionIds) {
                const htmlString = sections[sectionId];
                const html = new DOMParser().parseFromString(htmlString, 'text/html');
                const sourceElement = html.querySelector(`${sectionId}`);
                const targetElement = document.querySelector(`${sectionId}`);
                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }
              }
              document.body.classList.add('overflow-hidden');
              const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
              theme_cart.classList.add('active');

              // Update UpSellSlider
              window.initUpsellSwiper();
               checkIfAllUpsellsAdded();
            })
            .catch(err => console.error('Error updating cart drawer:', err));
      })
    }
  });

  // --- Initial load ---
  document.addEventListener('DOMContentLoaded', window.initUpsellSwiper);
   checkIfAllUpsellsAdded();

})();

/*End Cart Upcell js */

$(document).ready(function () {
  var $text = $('.scrolling-text');
  var $container = $('.scrolling-text-container');
  var originalText = $text.text().trim();
  var repeatedText = originalText + '\u00A0\u00A0';
  $text.text('');

  // Repeat text until it covers at least twice the container width
  while ($text.width() < $container.width() * 2) {
    $text.append(repeatedText);
  }

  var pos = 0;
  function scrollLoop() {
    pos -= 1;
    if (Math.abs(pos) >= $text.width() / 2) {
      pos = 0;
    }
    $text.css('transform', 'translateX(' + pos + 'px)');
    requestAnimationFrame(scrollLoop);
  }

  scrollLoop();
});

document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".lather-lab-swiper", {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    autoplay: true,
    breakpoints: {
      768: { slidesPerView: 3 },
      481: { slidesPerView: 2 },
      0: { slidesPerView: 1 },
    }
  });
});

$(document).ready(function() {
  $(".faq-section").each(function() {
    const $section = $(this);

    $section.on("click", ".faq-question", function() {
      const $question = $(this);
      const isActive = $question.hasClass("active");

      // Close all questions in this section
      $section.find(".faq-question").removeClass("active")
              .parent().removeClass("active")
              .find(".faq-answer").css("max-height", "0");

      // Open clicked one if it was not active
      if (!isActive) {
        $question.addClass("active");
        $question.parent().addClass("active");
        $question.next(".faq-answer").css("max-height", $question.next(".faq-answer")[0].scrollHeight + "px");
      }
    });
  });
});

// -------------------- Product Addons JS   --------------------------
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('.product-template-soap-addons');
  if (!container) return; // If container doesn't exist, exit

  // Elements inside the container
  const quantityInputs = container.querySelectorAll('.quantity');
  const subscribeBtn = container.querySelector('.subscribe-btn');
  const increaseBtns = container.querySelectorAll('.increase');
  const decreaseBtns = container.querySelectorAll('.decrease');
  const radios = container.querySelectorAll('input[name="purchase_option"]');
  const subscribeSelect = container.querySelector('#sellingplan');
  const onetimePriceEl = container.querySelector('.onetime-price');
  const originalPriceEl = container.querySelector('.subscribe-original-price');
  const discountedPriceEl = container.querySelector('.subscribe-discounted-price');

  // --- Button handlers ---
  increaseBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      const quantityForm = btn.closest('.quantity-form');
      if (!quantityForm) return console.warn('No .quantity-form for increase button');

      const input = quantityForm.querySelector('.quantity');
      if (!input) return console.warn('No .quantity input found');

      input.value = (parseInt(input.value, 10) || 0) + 1;
      updatePricesAndButton();
    });
  });

  decreaseBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      const quantityForm = btn.closest('.quantity-form');
      if (!quantityForm) return console.warn('No .quantity-form for decrease button');

      const input = quantityForm.querySelector('.quantity');
      if (!input) return console.warn('No .quantity input found');

      let value = parseInt(input.value, 10) || 0;
      if (value > 0) input.value = value - 1;
      updatePricesAndButton();
    });
  });

  quantityInputs.forEach(input => {
    input.addEventListener('input', function () {
      updatePricesAndButton();
    });
  });

  // --- Radio buttons ---
  radios.forEach(radio => {
    radio.addEventListener('change', function () {
      container.querySelectorAll('.form-control').forEach(group => group.classList.remove('selected'));
      const selectedGroup = radio.closest('.form-control');
      if (selectedGroup) selectedGroup.classList.add('selected');

      if (radio.value === 'subscribe' && subscribeSelect) {
        subscribeSelect.style.display = 'block';
      } else if (subscribeSelect) {
        subscribeSelect.style.display = 'none';
      }

      updatePricesAndButton();
    });
  });

  if (subscribeSelect) {
    subscribeSelect.addEventListener('change', function () {
      updatePricesAndButton();
    });
  }

  function updatePricesAndButton() {
    
    const discountPercent = 15; // 15% discount
    let totalCents = 0;
    let totalQty = 0;

    quantityInputs.forEach(input => {
      const quantityForm = input.closest('.quantity-form');
      if (!quantityForm) return;

      const priceInput = quantityForm.querySelector('.addon-price');
      if (!priceInput) return;

      const qty = parseInt(input.value, 10) || 0;
      const priceCents = parseInt(priceInput.value || 0);

      totalQty += qty;
      totalCents += qty * priceCents;
    });

    const totalPrice = totalCents / 100;
    const discountAmount = (totalPrice * discountPercent) / 100;
    const finalPrice = totalPrice - discountAmount;

    // --- Show prices ---
    if (onetimePriceEl) onetimePriceEl.textContent = totalQty ? `$${totalPrice.toFixed(2)}` : '';
    if (originalPriceEl && discountedPriceEl) {
      if (totalQty) {
          originalPriceEl.innerHTML = `<s>$${totalPrice.toFixed(2)}</s>`;
          discountedPriceEl.textContent = ` $${finalPrice.toFixed(2)}`;
      } else {
          originalPriceEl.textContent = '';
          discountedPriceEl.textContent = '';
      }
    }

    // --- Update button ---
    if (subscribeBtn) {
      const selectedOption = container.querySelector('input[name="purchase_option"]:checked');
      let buttonText = '';
      let disabled = totalQty === 0;

      if (selectedOption?.value === 'subscribe') {
          buttonText = totalQty >= 2 ? `$${finalPrice.toFixed(2)} - Add Subscription` : 'Select 2 to subscribe';
          disabled = totalQty < 2;
      } else {
          buttonText = totalQty ? `$${totalPrice.toFixed(2)} - Add to Cart` : 'Add to Cart';
      }

      subscribeBtn.textContent = buttonText;
      subscribeBtn.disabled = disabled;
      subscribeBtn.classList.toggle('active', !disabled);
    }
  }
  // --- Initial call ---
  updatePricesAndButton();
});
// -------------------- Product Addons JS   --------------------------

$(document).ready(function () {
  // Select selling plan

  $(document).on("change", "#sellingplan", function() {


    var selectedPlanName = $(this).val();

    $(".addtocart-sm").addClass("btn-disable-true");

    console.log(selectedPlanName);
    
     $( ".product-card" ).each(function() {
        var phandle = $( this ).find(".p-handle").val();
        var matchingPlanId = null;

        fetch(`/products/${phandle}.js`) // This only works if productId is actually a handle, otherwise needs storefront API
        .then(res => res.json())
        .then(product => {
            // Find matching selling_plan_id
            
            product.selling_plan_groups.forEach(slplan => {
                slplan.selling_plans.forEach(allocation => {
                  console.log(allocation.name);
                    if (allocation.name.trim().toLowerCase() === selectedPlanName.trim().toLowerCase()) {
                        matchingPlanId = allocation.id;
                    }
                });
            });

            console.log(matchingPlanId);
            $(this).find(".selling-pid").val(matchingPlanId);
        });
        
      });

      $(".addtocart-sm").removeClass("btn-disable-true");

  });

  // Select ontime plan

  $(document).on("change", ".purchase-type", function() {
    const selectedOption = $('input[name="purchase_option"]:checked').val();
    if (selectedOption === 'onetime') {
      $(".selling-pid").val("");
      $('#sellingplan').val("");

    }

  });

  // Add to cart js
  $(document).on("click", ".addtocart-sm", function() {

    // Btn text updates
    var btnThis = jQuery(this);
    var currentBtntext = btnThis.text();
    btnThis.removeClass("active");
    btnThis.text("Adding...");


    const form = document.getElementById("gs-addon-product-from");
    const formData = new FormData(form);

    // Check selling plan 

    const selectedOption = $('input[name="purchase_option"]:checked').val();
    if (selectedOption === 'subscribe') {
      selectedPlanId = $('#sellingplan').val();
      if(selectedPlanId == "") {
        alert("Please select plan to continue.");
        return false;
      }
    }

    const items = [];

    $( ".product-card" ).each(function() {
        var pid = $( this ).find(".pid-sm").val();
        var pqty = $( this ).find(".quantity").val();
        var slid = $( this ).find(".selling-pid").val();

         var item = {
            id: pid,
            quantity: pqty,
            selling_plan: slid
          };

          items.push(item);
          
    });

    const jsonData = {
      form_type: formData.get("form_type"),
      utf8: formData.get("utf8"),
      items: items,
    };

    const json = JSON.stringify(jsonData);

    console.log(json);

    fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(jsonData)
      }).then((res) => {
        if (res.ok) {
  
          fetch(`${routes.cart_url}?sections=cart-drawer`)
          .then((response) => response.json())
          .then((sections) => {
            const sectionIds = ['cart-drawer'];
            for (const sectionId of sectionIds) {
              const htmlString = sections[sectionId];
              const html = new DOMParser().parseFromString(htmlString, 'text/html');
              const sourceElement = html.querySelector(`${sectionId}`);
              const targetElement = document.querySelector(`${sectionId}`);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
            document.body.classList.add('overflow-hidden');
            const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
            theme_cart.classList.add('active');

            // Update UpCellSilder
            window.initUpsellSwiper();
            btnThis.text(currentBtntext);
            btnThis.addClass("active");
          })
          .catch((e) => {
            console.error('Error updating cart sections:', e);
          });
        }
      });
    return false;
  })
  
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.color-swatches .color-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function (e) {
      e.preventDefault();
      let newImage = this.getAttribute('data-image');
      let productCard = this.closest('.card');
      let mainImage = productCard.querySelector('.card__media img');

      if (mainImage) {
        mainImage.src = newImage;
        mainImage.srcset = newImage;
      }
    });
  });
});

// Mega Menu
$(document).ready(function () {
  var $header = $('.header-wrapper');
  var $megaMenu = $('.mega-menu-section');
  /* Trigger ID derives from the menu link's handle, which Shopify regenerates
     when the merchant renames the link. Match historical 'shop-all' and the
     current 'shop' label so renames between those two don't break hover. */
  var $menuTrigger = $('#HeaderMenu-shop-all, #HeaderMenu-shop');

  $megaMenu.hide();

  if ($header.length && $megaMenu.length) {
    $header.append($megaMenu);
  }

  var hoverTimeout;

  $menuTrigger.add($megaMenu).hover(
    function () {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(function () {
        $megaMenu.stop(true, true).fadeIn(200).addClass('active');
        $menuTrigger.addClass('active');
      }, 100);
    },
    function () {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(function () {
        $megaMenu.stop(true, true).fadeOut(200, function () {
          $(this).removeClass('active');
        });
        $menuTrigger.removeClass('active');
      }, 200);
    }
  );
});

document.addEventListener('DOMContentLoaded', function () {
  var quiz = document.querySelector('.quiz-btn-wr');
  if (!quiz) return;

  // placeholder to avoid jump
  var placeholder = document.createElement('div');
  placeholder.className = 'quiz-btn-placeholder';
  quiz.parentNode.insertBefore(placeholder, quiz);

  var header = document.querySelector('.section-header') 
            || document.querySelector('sticky-header') 
            || document.querySelector('header');
  if (!header) return;

  function getHeaderHeight() {
    if (header.classList.contains('scrolled-past-header')) {
      return header.offsetHeight || 80;
    }

    // Var ya fallback
    var cssVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseFloat(cssVar) || header.offsetHeight || 80;
  }

  // initial offset of banner/button
  var quizTop = quiz.getBoundingClientRect().top + window.pageYOffset;

  function update() {
    var headerH = getHeaderHeight();

    document.documentElement.style.setProperty('--header-height', headerH + 'px');

    if (window.pageYOffset > (quizTop - headerH - 8)) {
      quiz.classList.add('is-fixed');
      placeholder.style.height = quiz.offsetHeight + 'px';
    } else {
      quiz.classList.remove('is-fixed');
      placeholder.style.height = '0px';
    }
  }

  // ---- main scroll listener ----
  window.addEventListener('scroll', update, { passive: true });

  window.addEventListener('resize', function () {
    quizTop = quiz.getBoundingClientRect().top + window.pageYOffset;
    update();
  });

  // Recalculate after fonts/images load, then run update()
  window.setTimeout(function () {
    quizTop = quiz.getBoundingClientRect().top + window.pageYOffset;
    update();
  }, 50);

  // run once on load
  update();
});

// --------------QUIZ JS-------------------

 /* Step 01 Enable disable Continue Button */
  const step1ContinueBtn = document.querySelector('.step-1 .continue-btn');
  const step1InfoMsg = document.querySelector('.step-1 .step-continue-btn p');

  function updateStep1ContinueBtnState(qty) {

    if (!step1ContinueBtn) return;
    if (qty > 0) {
      step1ContinueBtn.classList.remove('disabled');
      step1ContinueBtn.removeAttribute('aria-disabled');
      if (step1InfoMsg) step1InfoMsg.style.display = 'none';
    } else {
      step1ContinueBtn.classList.add('disabled');
      step1ContinueBtn.setAttribute('aria-disabled', 'true');
      if (step1InfoMsg) step1InfoMsg.style.display = 'block';
    }
  }

  $(document).ready(function() {

    // Change variation for Step 1
    $(document).on("change", ".gmq-variant-options", function () {
        var vid = $(this).val();
        var vimg = $(this).attr("data-main");
        $(this).parents(".gtms-pop-right").find(".addtokit-btn").attr("add-variant-id", vid);
        $(this).parents(".gtms-pop-right").find(".addtokit-btn").attr("add-variant-img", vimg);
        $(this).parents(".step-gs-items").find(".popup-main-image img").attr("src", vimg);

    });

    // Change variation for Step 4
    $(document).on("change", ".gmq-variant-options-four", function () {
        var vid = $(this).val();
        var vimg = $(this).attr("data-main");
        $(this).parents(".product-image").find(".pid-sm").val(vid);
        $(this).parents(".ex-quize-product-wr").find(".main-img").attr("src", vimg);
    });

    // Add to Kit
    $(document).on("click", ".addtokit-btn", function() {

      var cthis = $(this);

      cthis.parents('.step-gs-items').find(".add-btn").hide();
      cthis.parents('.step-gs-items').find(".qty-input").val(1);
      cthis.parents('.step-gs-items').find(".quantity-selector").css("display", "inline-flex");
      
      // Enable Continue button
      updateStep1ContinueBtnState(1);

      return false;

    });

    // Get data for Setp 3 Dyanmic

    $(document).on("click", ".step-two-continue-gmp", function () {
      var planProducthandle = $(this).attr("plan-product-handle");

      fetch(`/products/${planProducthandle}.js`)
          .then(res => res.json())
          .then(product => {
              let html = '';

              // Assume first variant's price as base for display
              let basePrice = product.variants[0].price; // in cents
              let basePriceFloat = basePrice / 100;

              product.selling_plan_groups.forEach(slplan => {
                  slplan.selling_plans.forEach(plan => {
                      // Default: same as base price
                      let finalPrice = basePriceFloat;

                      // Look for price adjustments in the plan
                      if (plan.price_adjustments && plan.price_adjustments.length > 0) {
                          let adjustment = plan.price_adjustments[0];
                          if (adjustment.value_type === "percentage") {
                              finalPrice = basePriceFloat * (1 - adjustment.value / 100);
                          } else if (adjustment.value_type === "fixed_amount") {
                              finalPrice = basePriceFloat - adjustment.value / 100;
                          } else if (adjustment.value_type === "price") {
                              finalPrice = adjustment.value / 100;
                          }
                      }
                      // Build HTML
                      html += `
                          <div class="step-3-price-box select-selling-quize-plan" data-selling-plan-name="${plan.name}" data-selling-plan-id="${plan.id}">
                              <div class="checkbox-image">
                                <img src="https://cdn.shopify.com/s/files/1/0585/6988/3816/files/Vector.png?v=1754978853" alt="" class="checkbox-img">
                                <img src="https://cdn.shopify.com/s/files/1/0585/6988/3816/files/Icon_Container.png?v=1754978953" alt="" class="fill-checkbox-img">
                              </div>
                              <h4 class="month-title">${plan.name}</h4>
                              <h5 class="month-price">$${(finalPrice / 2).toFixed(2)} per bar</h5>
                          </div>
                      `;
                  });
              });

              $(".step-3-boxes").html(html);
              // $(".one-time-gmproduct-price").html("$"+basePriceFloat.toFixed(2)+" per bar");
              $(".one-time-gmproduct-price").html("$"+(basePriceFloat / 2).toFixed(2)+" per bar");
              $(".step-2").fadeOut();
              $(".step-3").fadeIn()
          })
          .catch(err => console.error("Error fetching product:", err));
    });

    // Select Selling Plan

    $(document).on("click", ".select-selling-quize-plan", function() {

      if(!$(this).hasClass("active")) {
          var selectedPlanName = $(this).attr("data-selling-plan-name");

          // Remove 'active' from all and add to clicked one
          $(".select-selling-quize-plan").removeClass("active");
          $(this).addClass("active");

          console.log(selectedPlanName);

          $(".one-time-order").removeClass("active");
          $(".sl-planbtn-conti").removeClass("disabled");
          
          $(".step-gs-items-addons").each(function() {
              var phandle = $(this).find(".p-handle").val();
              var matchingPlanId = null;

              fetch(`/products/${phandle}.js`)
              .then(res => res.json())
              .then(product => {
                  product.selling_plan_groups.forEach(slplan => {
                      slplan.selling_plans.forEach(allocation => {
                          if (allocation.name.trim().toLowerCase() === selectedPlanName.trim().toLowerCase()) {
                              matchingPlanId = allocation.id;
                          }
                      });
                  });

                  console.log(matchingPlanId);
                  $(this).find(".selling-pid").val(matchingPlanId);
              });
          });
      }
    });


    // Click of one time Purches

    $(document).on("click", ".one-time-order", function() {
      if(!$(this).hasClass("active")) {
        $(".selling-pid").val("");
        $(this).addClass("active");
        $(".select-selling-quize-plan").removeClass("active");
        $(".sl-planbtn-conti").removeClass("disabled");
      }
    });

    // Move to cart or review cart step 4 click

    $(document).on("click", ".move-to-cart-btn", function() {

      // Btn text updates
      var btnThis = jQuery(this);
      var currentBtntext = btnThis.text();
      btnThis.addClass("btn-disabled");
      btnThis.text("Adding...");

      const items = [];

      // Step one Data
      $(".step-gs-items").each(function() {
          var step_one_vid = $( this ).find(".gsmq-step-pid").val();
          var step_one_qty = $( this ).find(".gsmq-step-qty").val();


          var item = {
              id: step_one_vid,
              quantity: step_one_qty,
            };

            console.log(item);

            items.push(item);
            
      });

      // Step Two data
      $( ".step-gs-items-addons" ).each(function() {
          var pid = $( this ).find(".pid-sm").val();
          var pqty = $( this ).find(".quantity").val();
          var slid = $( this ).find(".selling-pid").val();

          var item = {
              id: pid,
              quantity: pqty,
              selling_plan: slid
            };

            console.log(item);

            items.push(item);
            
      });

      // Step Four Data
      $( ".ex-quize-product-wr" ).each(function() {
          var step_four_vid = $( this ).find(".pid-sm").val();
          var step_four_qty = $( this ).find(".quantity").val();


          var item = {
              id: step_four_vid,
              quantity: step_four_qty,
            };

            console.log(item);

            items.push(item);
            
      });

       // console.log(items);

      const jsonData = {
        form_type: 'product',
        utf8: "utf8",
        items: items,
      };

      const json = JSON.stringify(jsonData);

      console.log(json);

      fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(jsonData)
        }).then((res) => {
          // if (res.ok) {
    
          //   fetch(`${routes.cart_url}?sections=cart-drawer`)
          //   .then((response) => response.json())
          //   .then((sections) => {
          //     const sectionIds = ['cart-drawer'];
          //     for (const sectionId of sectionIds) {
          //       const htmlString = sections[sectionId];
          //       const html = new DOMParser().parseFromString(htmlString, 'text/html');
          //       const sourceElement = html.querySelector(`${sectionId}`);
          //       const targetElement = document.querySelector(`${sectionId}`);
          //       if (targetElement && sourceElement) {
          //         targetElement.replaceWith(sourceElement);
          //       }
          //     }
          //     document.body.classList.add('overflow-hidden');
          //     const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          //     if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
          //     theme_cart.classList.add('active');

          //     // Update UpCellSilder
          //     window.initUpsellSwiper();

          //     btnThis.text(currentBtntext);
              
          //   })
          //   .catch((e) => {
          //     console.error('Error updating cart sections:', e);
          //   });
          // }

          if (res.ok) {
              // Redirect directly to cart page
              window.location.href = '/cart';
          } else {
              // Optional: handle errors
              res.json().then(data => {
                  alert(data.description || "Error updating cart sections");
              });
          }

        });

      return false;
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    /* Common function to setup quantity selector behavior for any container */
    function setupQuantitySelector(container) {

      const addBtn = container.querySelector('.add-btn');
      const qtySelector = container.querySelector('.quantity-selector');
      const qtyInput = qtySelector ? qtySelector.querySelector('.qty-input') : null;
      const decreaseBtn = qtySelector ? qtySelector.querySelector('.qty-decrease') : null;
      const increaseBtn = qtySelector ? qtySelector.querySelector('.qty-increase') : null;

      if (!addBtn || !qtySelector || !qtyInput || !decreaseBtn || !increaseBtn) return;

      // Hide quantity selector initially and qty=0
      qtyInput.value = 0;
      qtySelector.style.display = 'none';
      addBtn.style.display = 'inline-block';

      decreaseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let val = parseInt(qtyInput.value);
        if (val > 1) {
          qtyInput.value = val - 1;   // 3 → 2 (no reset)
        } else {
          qtyInput.value = 0;
          qtySelector.style.display = 'none';
          addBtn.style.display = 'inline-block';

          // ✅ Reset only .stpone-feature-img
          const cardImg = container.querySelector('.stpone-feature-img img');
          if (cardImg && cardImg.hasAttribute('data-default')) {
            cardImg.setAttribute('src', cardImg.getAttribute('data-default'));
          }
        }
        updateStep1ContinueBtnState(parseInt(qtyInput.value));
      });


      increaseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let val = parseInt(qtyInput.value);
        qtyInput.value = val + 1;
        updateStep1ContinueBtnState(parseInt(qtyInput.value));
      });

      qtyInput.addEventListener('input', () => {
        let val = parseInt(qtyInput.value);
        if (val <= 0 || isNaN(val)) {
          qtyInput.value = 0;
          qtySelector.style.display = 'none';
          addBtn.style.display = 'inline-block';

          // ✅ Reset only .stpone-feature-img
          const cardImg = container.querySelector('.stpone-feature-img img');
          if (cardImg && cardImg.hasAttribute('data-default')) {
            cardImg.setAttribute('src', cardImg.getAttribute('data-default'));
          }
        }
        updateStep1ContinueBtnState(parseInt(qtyInput.value));
      });
    }

      /* Setup all quantity selectors inside step-1 or popup product images */
        document.querySelectorAll('.product-image').forEach((productImageDiv) => {
        setupQuantitySelector(productImageDiv);
    });

    document.querySelectorAll('.popup-close').forEach((btn) => {
      btn.addEventListener('click', function () {
        let popup = this.closest('.popup-overlay');
        popup.style.display = 'none';

        // ✅ Reset all variant radio selections
        popup.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          radio.checked = false;
        });

        // ✅ Reset main image to default featured image
        let mainImg = popup.querySelector('[id^="main-img-"]');
        if (mainImg && mainImg.getAttribute('data-default')) {
          mainImg.src = mainImg.getAttribute('data-default');
        }
      });
    });


  /* Close poup for Quick Cart using Overlay */
    document.querySelectorAll('.popup-overlay').forEach((overlay) => {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) overlay.style.display = 'none';
      });
    });

    /* Thumbnail click image change on Popup main image slider*/
    document.querySelectorAll('.thumb-img').forEach((thumb) => {
      thumb.addEventListener('click', function () {
        const mainImg = document.getElementById(`main-img-${this.dataset.product}`);
        if (mainImg) {
          mainImg.src = this.dataset.main;
        }
        this.closest('.popup-thumbs')
          .querySelectorAll('img')
          .forEach((img) => img.classList.remove('active'));
        this.classList.add('active');
      });
    });

    /* Step-1 Continue button click show Step-2 */
    if (step1ContinueBtn) {
      step1ContinueBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!this.classList.contains('disabled')) {
          document.querySelector('.step-1').style.display = 'none';
          document.querySelector('.step-2').style.display = 'block';
        }
      });
    }

    /* ============================
    STEP 2: ADD/QUANTITY LOGIC
    ============================ */
    const stepWrapper = document.querySelector('.step.step-2');

    if (stepWrapper) {

      const addButtons = stepWrapper.querySelectorAll('.product-addons-wr .add-btn');
      const continueBtn = stepWrapper.querySelector('.continue-btn');
      const quantityInputs = stepWrapper.querySelectorAll('.quantity');
      const infoMsg = stepWrapper.querySelector('.step-continue-btn p');

      quantityInputs.forEach((input) => (input.value = 0));

      function updateContinueState() {
        let totalQty = 0;
        quantityInputs.forEach((input) => {
          totalQty += parseInt(input.value) || 0;
        });

        if (totalQty >= 2) {
          continueBtn.classList.remove('disabled');
          continueBtn.removeAttribute('aria-disabled');
          if (infoMsg) infoMsg.style.display = 'none';
        } else {
          continueBtn.classList.add('disabled');
          continueBtn.setAttribute('aria-disabled', 'true');
          if (infoMsg) infoMsg.style.display = 'block';
        }
      }
      updateContinueState();

      addButtons.forEach((btn) => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          const productWr = btn.closest('.product-addons-wr');
          btn.style.display = 'none';
          productWr.querySelector('.quantity-form').style.display = 'block';
          productWr.querySelector('.quantity').value = 1;
          updateContinueState();
        });
      });

      stepWrapper.addEventListener('click', function (e) {
        if (e.target.closest('.increase')) {
          const input = e.target.closest('.quantity-selector').querySelector('.quantity');
          input.value = parseInt(input.value) + 1;
          updateContinueState();
        }
        if (e.target.closest('.decrease')) {
          const input = e.target.closest('.quantity-selector').querySelector('.quantity');
          let newVal = parseInt(input.value) - 1;
          if (newVal <= 0) {
            const productWr = e.target.closest('.product-addons-wr');
            productWr.querySelector('.quantity-form').style.display = 'none';
            productWr.querySelector('.add-btn').style.display = 'block';
            newVal = 0;
          }
          input.value = newVal;
          updateContinueState();
        }
      });

      quantityInputs.forEach((input) => {
        input.addEventListener('input', updateContinueState);
      });

      const step3ContinueBtn = document.querySelector('.step-3 .continue-btn');
      if (step3ContinueBtn) {
        step3ContinueBtn.addEventListener('click', function (e) {
          e.preventDefault();
          document.querySelector('.step-3').style.display = 'none';
          document.querySelector('.step-4').style.display = 'block';
        });
      }
    }

    /* Step-4 Quantity Logic */

    const step4Wrapper = document.querySelector('.step.step-4');

    if (step4Wrapper) {

      const addButtons4 = step4Wrapper.querySelectorAll('.product-addons-wr .add-btn');
      const quantityInputs4 = step4Wrapper.querySelectorAll('.quantity');

      quantityInputs4.forEach((input) => (input.value = 0));

      addButtons4.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const productWr = btn.closest('.product-addons-wr');
          btn.style.display = 'none';
          productWr.querySelector('.quantity-form').style.display = 'block';
          productWr.querySelector('.quantity').value = 1;
        });
      });

      step4Wrapper.addEventListener('click', (e) => {
        if (e.target.closest('.increase')) {
          const input = e.target.closest('.quantity-selector').querySelector('.quantity');
          input.value = parseInt(input.value) + 1;
        }
        if (e.target.closest('.decrease')) {
          const input = e.target.closest('.quantity-selector').querySelector('.quantity');
          let newVal = parseInt(input.value) - 1;
          if (newVal <= 0) {
            const productWr = e.target.closest('.product-addons-wr');
            productWr.querySelector('.quantity-form').style.display = 'none';
            productWr.querySelector('.add-btn').style.display = 'block';
            newVal = 0;
          }
          input.value = newVal;
        }
      });

      quantityInputs4.forEach((input) => {
        input.addEventListener('input', () => {
          if (parseInt(input.value) <= 0 || isNaN(input.value)) {
            const productWr = input.closest('.product-addons-wr');
            productWr.querySelector('.quantity-form').style.display = 'none';
            productWr.querySelector('.add-btn').style.display = 'block';
            input.value = 0;
          }
        });
      });
    }
  });
// --------------End QUIZ JS-------------------

document.addEventListener("DOMContentLoaded", function () {
  const $testimonialslider = $('.press-testimonials-wrapper .press-testimonials');

  function initSlider() {
    if ($(window).width() <= 979) {
      if (!$testimonialslider.hasClass('slick-initialized')) {
        $testimonialslider.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: true,
          responsive: [
            {
              breakpoint: 569,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
      }
    } else {
      if ($testimonialslider.hasClass('slick-initialized')) {
        $testimonialslider.slick('unslick');
      }
    }
  }

  initSlider();
  $(window).on('resize', initSlider);
});

document.addEventListener('DOMContentLoaded', function() {
  new Swiper('.smoosh-stats', {
    slidesPerView: 1.16,
    spaceBetween: 14,
    autoplay: true,
    loop: true,
    breakpoints: {
      800: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
        501: {
        slidesPerView: 2,
        spaceBetween: 20,
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  var featuredSection = document.querySelector(".drawer-featured");
  var drawerDetails = document.querySelectorAll("#menu-drawer details");

  drawerDetails.forEach(function(detail) {
    detail.addEventListener("toggle", function() {
      var anyOpen = Array.from(drawerDetails).some(d => d.open);

      if (featuredSection) {
        if (anyOpen) {
          featuredSection.classList.add("hidden"); // fade out
        } else {
          featuredSection.classList.remove("hidden"); // fade in
        }
      }
    });
  });
});

function resetPopupVariants(popup) {
  if (!popup) return;

  // Uncheck all radio buttons inside popup
  popup.querySelectorAll('input[type="radio"]').forEach((radio) => {
    radio.checked = false;
  });

  // Reset main popup image with fade
  let $mainImg = $(popup).find('.popup-main-image img');
  let defaultSrc = $mainImg.attr("data-default");

  if ($mainImg.length && defaultSrc) {
    $mainImg.fadeOut(300, function () {
      $mainImg.attr("src", defaultSrc).fadeIn(300);
    });
  }
}

/* === Close popup via X button === */
document.querySelectorAll('.popup-close').forEach((btn) => {
  btn.addEventListener('click', function () {
    let popup = this.closest('.popup-overlay');
    resetPopupVariants(popup);
    popup.style.display = 'none';
  });
});

/* === Close popup via overlay click === */
document.querySelectorAll('.popup-overlay').forEach((overlay) => {
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      resetPopupVariants(overlay);
      overlay.style.display = 'none';
    }
  });
});

/* === Close popup via Add to Kit === */
$(document).on("click", ".addtokit-btn", function () {
  var popup = $(this).closest(".popup-overlay")[0];

  // 👇 after your add-to-kit logic
  $(popup).fadeOut();
  resetPopupVariants(popup);

  return false;
});

// Only digits allow
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".quantity").forEach(function(input) {
    input.addEventListener("input", function () {
      this.value = this.value.replace(/[^0-9]/g, "");
    });
  });
});

$(document).ready(function() {
  $('.product-form__quantity, .product-buy-btn').wrapAll('<div class="quanity-buy-wr"></div>');
});

document.addEventListener('DOMContentLoaded', function () {
  const ratingCount = document.querySelector('.rating-wrapper');
  const reviewsSection = document.getElementById('main-product-reviews');
 
  if (ratingCount && reviewsSection) {
    ratingCount.addEventListener('click', function (e) {
      e.preventDefault(); // stop default link (if any)
      reviewsSection.scrollIntoView({ behavior: 'smooth' });
    });
  }
});

$(document).ready(function() {
  $(".product-rating-wr").on("click", function(e) {
    e.preventDefault();

    // Provide the ID of the section you want to scroll to here
    var target = $("#main-product-reviews"); 

    if (target.length) {
      var headerHeight = $("header").outerHeight() || 80; // Detect the header height
      var extraOffset = 20; // Leave a little extra gap

      $("html, body").animate({
        scrollTop: target.offset().top - headerHeight - extraOffset
      }, 600); // 600 = animation speed
    }
  });
});

$(document).ready(function() {

  // Hide thumbnails, arrows, info by default
  $(".thumbnail-images-wrapper, .thumb-arrow-prev, .thumb-arrow-next, .main-image-info").hide();

  $(document).on("click", ".product-card", function() {

    // ---- Main image, title, description ----
    var mainImg = $(this).data("image") || "";
    var images = $(this).data("images") || "";
    var title = $(this).data("title") || "";
    var desc = $(this).data("description") || "";

    if(mainImg.startsWith("//")) mainImg = "https:" + mainImg;

    $(".main-preview-img").attr("src", mainImg);
    $(".main-image-title").text(title);
    $(".main-image-description").text(desc);
    $(".main-image-info").show();

    // ---- Thumbnails ----
    var $thumbWrapper = $(".thumbnail-images-wrapper");
    $thumbWrapper.empty();
    var imgArray = images.split(",").map(i=>i.trim()).filter(Boolean);

    if(imgArray.length === 0){
      $thumbWrapper.hide();
      $(".thumb-arrow-prev, .thumb-arrow-next").hide();
    } else {
      imgArray.forEach(function(imgUrl, idx){
        if(imgUrl.startsWith("//")) imgUrl = "https:" + imgUrl;
        $thumbWrapper.append(`
          <div class="thumb-item">
            <img src="${imgUrl}" class="${idx===0?'active-thumb':''}">
          </div>
        `);
      });
      $thumbWrapper.show();
      if(imgArray.length <= 4){
        $(".thumb-arrow-prev, .thumb-arrow-next").hide();
      } else {
        $(".thumb-arrow-prev, .thumb-arrow-next").show();
      }
    }

    // ---- Rating + Reviews ----
    $(".main-image-info .product-rating-wrapper").remove();

    var ratingValue = parseFloat($(this).data("rating")) || 0;
    var ratingMax = parseInt($(this).data("rating-max")) || 5;
    var ratingCount = parseInt($(this).data("rating-count")) || 0;

    if(ratingValue > 0){
      var decimal = ratingValue % 1;
      var ratingDecimal = 0;
      if(decimal >= 0.3 && decimal <= 0.7) ratingDecimal = 0.5;
      else if(decimal > 0.7) ratingDecimal = 1;

      var ratingHtml = `
        <div class="product-rating-wrapper">
          <div class="rating-wrapper" role="img" aria-label="Rated ${ratingValue} out of ${ratingMax}">
            <span class="rating-star" style="--rating: ${Math.floor(ratingValue)}; --rating-decimal: ${ratingDecimal}; --rating-max: ${ratingMax};"></span>
            <span class="rating-count" aria-hidden="true">${ratingCount} reviews</span>
          </div>
        </div>
      `;

      $(".main-image-description").before(ratingHtml);
    }

  });

  // ---- Thumbnail click ----
  $(document).on("click", ".thumbnail-images-wrapper .thumb-item img", function(){
    var newSrc = $(this).attr("src");
    $(".main-preview-img").attr("src", newSrc);
    $(".thumbnail-images-wrapper .thumb-item img").removeClass("active-thumb");
    $(this).addClass("active-thumb");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".addons-product-swiper", {
    slidesPerView: 4,
    spaceBetween: 40,
    loop: true,
    autoplay: true,
    breakpoints: {
      981: { slidesPerView: 4 },
      768: { slidesPerView: 3 },
      575: { slidesPerView: 2 },
      320: { slidesPerView: 1 },
    }
  });
});

$(document).ready(function () {
  var swiper = new Swiper(".scrubber-slider", {
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".scrubber-slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      480: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
    }
  });
});